module.exports = __webpack_public_path__ + "static/media/logos_squares_Sup_HKGBC.5efc3120.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Sup_HKGBC.png
// module id = 57
// module chunks = 0